import type { Attraction } from '@/config/objects/attractions';
import { useOutletContext } from 'react-router-dom';

interface AttractionContext {
  attraction: Attraction | undefined;
  isLoading: boolean;
}

export function useAttractionContext() {
  return useOutletContext<AttractionContext>();
}
